{
    "BroadworksProvisioningHeader": "Provisionamento do Broadworks Service Pack",
    "BroadworksProvisioningTableHeaderEnabled": "Habilitado",
    "BroadworksProvisioningTableHeaderItem": "Item",
    "BroadworksProvisioningTableHeaderServicePack": "Pacote de serviço",
    "BroadworksProvisioningTableHeaderTelephonyServers": "Servidor(es) de telefonia",
    "BroadworksProvisioningAddEntry": "Adicionar entrada...",
    "BroadworksProvisioningItemExtension": "Extensão",
    "BroadworksProvisioningItemHospitality": "Hospitalidade",
    "BroadworksProvisioningItemAcdAgent": "Agente ACD",
    "BroadworksProvisioningButtonDiscardChanges": "Descartar mudanças",
    "BroadworksProvisioningButtonSave": "Salvar",
    "BroadworksProvisioningButtonActions": "Ações",
    "BroadworksProvisioningButtonDelete": "Excluir",
    "BroadworksProvisioningButtonEdit": "Editar",
    "BroadworksProvisioningValueIsRequired": "Valor é requerido.",
    "NAME": "Provisioning",
    "BroadworksProvisioningTableHeaderSendWelcomeEmail": "Enviar e-mail de boas-vindas",
    "BroadworksProvisioningItemEssentials": "Essenciais",
    "BroadworksProvisioningItemProfessional": "Profissional",
    "BroadworksProvisioningItemCallCentreAgent": "Agente do centro de atendimento",
    "BroadworksProvisioningItemEnterprise": "Empresa",
    "BroadworksProvisioningItemCallCentreSupervisor": "Supervisor do centro de atendimento",
    "BroadworksProvisioningItem1000": "Akixi 1000",
    "BroadworksProvisioningItem2000": "Akixi 2000"
}